import type { Landmark } from '../../../data/types';
import type { MeshBuilder } from '../../mesh/meshBuilder';
import { SURFACE } from '../../mesh/attributes';
import { buildConventRange } from './conventRange';
import { paintedChapelStyles, type PaintedChapelColors } from './paintedChapels';
import { meshFrameOf, planBounds, planFrameOf } from './planFrame';
import { NO_TRACERY } from './tracery/tracerySink';

/** The painted crosswise body is observed; its identification and detailed 1538 form are uncertain. */
export function sacramentsHallPlan(landmark: Landmark) {
  const plan = planFrameOf(landmark.footprint, landmark.heading),
    b = planBounds(plan);
  return {
    plan,
    part: {
      length: b.u1 - b.u0,
      width: b.v1 - b.v0,
      eaves: Number(landmark.params['height']),
      ridge: Number(landmark.params['ridgeHeight']),
      floors: 1,
      bays: 5,
      passage: 0,
      doorSide: 0,
      windowRows: [{ sill: 1.15, top: 3.2, width: 0.9 }],
    },
  };
}

/** One undivided hall; the three rental rooms recorded after 1545 are not projected backwards. */
export function buildSacramentsHall(
  builder: MeshBuilder,
  landmark: Landmark,
  colors: PaintedChapelColors,
  ids: { readonly edgeId: number; readonly seed: number }
): void {
  const { plan, part } = sacramentsHallPlan(landmark),
    styles = paintedChapelStyles(colors, ids, NO_TRACERY);
  buildConventRange(
    builder,
    meshFrameOf(plan),
    {
      ...styles,
      wall: { ...styles.wall, surface: SURFACE.brick },
    },
    part
  );
}
